// extracted by mini-css-extract-plugin
module.exports = {"categories":"BlogCategories_categories__2MObE"};